import { render, staticRenderFns } from "./ScrollButtons.vue?vue&type=template&id=ee0cdedc&scoped=true&"
import script from "./ScrollButtons.vue?vue&type=script&lang=ts&"
export * from "./ScrollButtons.vue?vue&type=script&lang=ts&"
import style0 from "./ScrollButtons.vue?vue&type=style&index=0&id=ee0cdedc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0cdedc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VFadeTransition,VIcon,VTooltip})
